module.exports = "v{{ version }}\r\n"